import { RouterProvider } from "@tanstack/react-router";
import { router } from "@/app/router";

export function AppRouterProvider() {
  return <RouterProvider router={router} />;
}
